import React from 'react'
import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { Scale, Building, FileText, AlertTriangle, Shield, Globe } from 'lucide-react'

const LegalNotice: React.FC = () => {
  const sections = [
    {
      title: '1. 公司信息',
      icon: Building,
      content: [
        '公司名称：DeepLink Limited',
        '注册地址：香港中环国际金融中心二期',
        '注册号码：根据香港公司注册处记录',
        '成立日期：2023年',
        '法律地位：根据香港《公司条例》注册的有限责任公司',
        '营业范围：Web3硬件设备研发、制造和销售'
      ]
    },
    {
      title: '2. 法律管辖',
      icon: Scale,
      content: [
        '本网站和所有相关服务受香港特别行政区法律管辖。',
        '任何争议应提交香港法院或香港国际仲裁中心解决。',
        '我们遵守香港所有适用的法律法规，包括但不限于：',
        '• 《个人资料（私隐）条例》（第486章）',
        '• 《商品说明条例》（第362章）',
        '• 《消费者委员会条例》（第216章）',
        '• 《电子交易条例》（第553章）',
        '• 《防止贿赂条例》（第201章）'
      ]
    },
    {
      title: '3. 知识产权声明',
      icon: FileText,
      content: [
        '本网站及其内容受版权法保护。',
        '我们拥有或获得许可使用以下知识产权：',
        '• 商标：DeepLink、CoreTrust及相关标识',
        '• 版权：网站设计、内容、软件代码',
        '• 专利：CoreTrust手机相关技术专利',
        '• 商业秘密：专有技术和商业信息',
        '未经我们书面许可，禁止复制、修改、分发或商业使用我们的知识产权。',
        '第三方商标和版权归其各自所有者所有。'
      ]
    },
    {
      title: '4. 免责声明',
      icon: AlertTriangle,
      content: [
        '本网站提供的信息仅供参考，不构成法律、财务或投资建议。',
        '我们尽力确保信息的准确性，但不保证信息的完整性、准确性或及时性。',
        '我们不对以下情况承担责任：',
        '• 因使用本网站信息而造成的任何损失',
        '• 网站中断、延迟或错误',
        '• 第三方网站的内容或服务',
        '• 病毒、恶意软件或其他有害程序',
        '• 不可抗力事件造成的损失',
        '用户应自行承担使用本网站的风险。'
      ]
    },
    {
      title: '5. 产品和服务声明',
      icon: Shield,
      content: [
        'CoreTrust手机及相关服务按"现状"提供。',
        '我们不保证产品和服务将满足您的特定需求。',
        '产品规格和功能可能随时更改，恕不另行通知。',
        '我们保留随时修改、暂停或终止任何服务的权利。',
        '服务可能因维护、升级或其他原因暂时中断。',
        '我们建议您定期备份重要数据。'
      ]
    },
    {
      title: '6. 第三方链接',
      icon: Globe,
      content: [
        '本网站可能包含指向第三方网站的链接。',
        '这些链接仅为方便用户而提供，不代表我们认可这些网站。',
        '我们不对第三方网站的内容、隐私政策或服务负责。',
        '用户访问第三方网站的风险由用户自行承担。',
        '我们建议用户查看第三方网站的条款和隐私政策。'
      ]
    },
    {
      title: '7. 数据保护',
      icon: Shield,
      content: [
        '我们按照香港《个人资料（私隐）条例》处理个人资料。',
        '我们采用适当的技术和组织措施保护您的资料安全。',
        '我们不会向第三方出售您的个人资料。',
        '我们仅在法律允许或获得您同意的情况下共享资料。',
        '您有权查阅、更正和删除您的个人资料。',
        '如需了解更多信息，请查看我们的隐私政策。'
      ]
    },
    {
      title: '8. 反洗钱和合规',
      icon: Scale,
      content: [
        '我们遵守香港反洗钱和反恐怖主义融资法规。',
        '我们实施适当的客户尽职调查程序。',
        '我们监控可疑交易并按要求报告。',
        '我们保留拒绝或终止可疑账户的权利。',
        '我们配合执法部门的调查工作。',
        '我们定期审查和更新合规程序。'
      ]
    },
    {
      title: '9. 争议解决',
      icon: Scale,
      content: [
        '因本网站或我们的服务产生的争议应通过以下方式解决：',
        '• 首先通过友好协商解决',
        '• 如协商不成，提交香港国际仲裁中心仲裁',
        '• 仲裁程序按照香港国际仲裁中心规则进行',
        '• 仲裁地点为香港',
        '• 仲裁语言为中文或英文',
        '仲裁裁决为终局裁决，对双方均有约束力。'
      ]
    },
    {
      title: '10. 政策更新',
      icon: FileText,
      content: [
        '我们可能会不时更新本法律声明。',
        '更新将通过以下方式通知：',
        '• 在网站上发布更新通知',
        '• 通过电邮发送通知',
        '• 通过CoreTrust手机应用推送通知',
        '继续使用我们的服务即表示您接受更新后的声明。',
        '如您不同意更新后的声明，可以停止使用我们的服务。',
        '建议您定期查看本声明的最新版本。'
      ]
    }
  ]

  return (
    <>
      <Helmet>
        <title>法律声明 - DeepLink Limited</title>
        <meta name="description" content="DeepLink Limited法律声明，受香港法律管辖" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto"
          >
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                法律声明
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                最后更新：2024年1月1日 | 生效日期：2024年1月1日
              </p>
              <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 max-w-2xl mx-auto">
                <p className="text-sm text-red-800 dark:text-red-200">
                  <strong>重要提示：</strong>本法律声明受香港特别行政区法律管辖。请仔细阅读并理解本声明的所有条款。
                </p>
              </div>
            </div>

            <div className="space-y-8">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6"
                >
                  <div className="flex items-center mb-4">
                    <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mr-4">
                      <section.icon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
                      {section.title}
                    </h2>
                  </div>
                  <div className="space-y-3">
                    {section.content.map((item, itemIndex) => (
                      <p key={itemIndex} className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        {item}
                      </p>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="mt-12 bg-gray-100 dark:bg-gray-800 rounded-lg p-6"
            >
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                联系我们
              </h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                如果您对本法律声明有任何疑问，请通过以下方式联系我们：
              </p>
              <div className="space-y-2">
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>电邮：</strong> legal@deeplink.hk
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>电话：</strong> +852 1234-5678
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>地址：</strong> 香港中环国际金融中心二期
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>注册办事处：</strong> 香港中环国际金融中心二期
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>法律顾问：</strong> 香港律师事务所
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  )
}

export default LegalNotice